import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import TopBackButton from '@/component/common/top-back-button';
import { SFPalette } from '@/lib/color';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import IconButton from '@mui/material/IconButton';
import CloseOutlined from '@mui/icons-material/CloseOutlined';
import RadioGroup from '@mui/material/RadioGroup';
import Box, { BoxProps } from '@mui/material/Box';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import EastIcon from '@mui/icons-material/East';
import Divider from '@mui/material/Divider';
import BulletList from '@/component/common/bullet-list';
import { inter } from '@/theme';
import SFAlert from '@/component/common/sf-alert';
import SFAccordion from '@/component/common/sf-accordion';
import { buy_contents } from '@/component/linkMobile/appPay';
import BottomFix from '@/component/common/bottom-fix';
import { inAppPaymentProps, insertInAppPayment } from '@/api/server/inapp_payment/create';
import { localSetStorage } from '@/lib/storage';
const CHARGE_RATIO = 0.03;

// ※ 인앱결제용 페이지 실제로 사용하지 않고 앱 심사 때만 사용하기 위한 꼼수

function ChargeAlert({ chargeAmount }: { chargeAmount: number }) {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <SFAlert
      title="충전 금액 확인"
      icon={
        <IconButton
          sx={{ p: 0 }}
          onClick={() => {
            navigate('/');
            // router.push('/point/charge/guide');
          }}
        >
          <ErrorOutlineIcon
            sx={{
              color: 'white',
            }}
          />
        </IconButton>
      }
    >
      <Box pt={2.5}>
        <Box mx={2.5}>
          <Stack direction="row" justifyContent="space-between">
            <Box>
              <Typography variant="body2" fontWeight={700} color={SFPalette.grey4}>
                충전 포인트
              </Typography>
              <Typography
                variant="h4"
                fontWeight={700}
                color={theme.palette.primary.main}
                fontFamily={inter.style.fontFamily}
              >
                {chargeAmount.toLocaleString('ko-KR')}
                {'P'}
              </Typography>
            </Box>
            <Stack justifyContent="center">
              <EastIcon
                sx={{
                  color: SFPalette.lightGrey1,
                }}
              />
            </Stack>
            <Box>
              <Typography variant="body2" fontWeight={700} color={SFPalette.grey4}>
                수수료 포함 결제 금액
              </Typography>
              <Typography
                variant="h4"
                fontWeight={700}
                color={theme.palette.primary.main}
                fontFamily={inter.style.fontFamily}
              >
                {(chargeAmount + chargeAmount * CHARGE_RATIO).toLocaleString('ko-KR')}
                {'₩'}
              </Typography>
            </Box>
          </Stack>
          <Typography variant="body2" color={SFPalette.lightGrey2}>
            수수료율 3%
          </Typography>
        </Box>
      </Box>
      <Divider
        sx={{
          my: 2.5,
        }}
      />
      <Box mx={2.5} pb={2.5}>
        <BulletList
          ml={1.25}
          list={[
            '충전 금액에 수수료가 합산된 금액이 결제됩니다.',
            '최소 충전 포인트: 5,000P',
            '보유 가능 최대 포인트: 2,000,000P',
            '일월 최대 충전 한도: 2,000,000P',
            '포인트 충전수수료를 제외한 한도입니다.',
          ]}
        />
      </Box>
    </SFAlert>
  );
}

const POINT = 100000;
function PointChargePage() {
  const [chargeAmount, setChargeAmount] = useState(0);
  const [displayValue, setDisplayValue] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('간편계좌');
  const [payId, setPayId] = useState('');

  const increaseChargeAmount = (amount: number) => {
    if (chargeAmount >= POINT) {
      return;
    }
    setChargeAmount((prevState) => prevState + amount);
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputVal = event.target.value;
    const numericInputVal = Number(inputVal.replace(/,/g, ''));
    setChargeAmount(numericInputVal);
  };

  useEffect(() => {
    const formattedChargeAmount = chargeAmount.toLocaleString('ko-KR');
    setDisplayValue(formattedChargeAmount);
  }, [chargeAmount]);

  const buyId = (aAmount: number) => {
    switch (aAmount) {
      case 5000:
        setPayId('cont001');
        break;
      case 10000:
        setPayId('cont002');
        break;
      case 30000:
        setPayId('cont003');
        break;
      case 50000:
        setPayId('cont004');
        break;
      case 100000:
        setPayId('cont005');
        break;
      default:
        setPayId('cont001');
        break;
    }
  };
  window.payment_result = (val: any) => {
    paymentResult(val);
  };
  // 테스트용 버튼
  const tempPaymentResultClick = () => {
    const payload = {
      title: '50,000p (Shuffle)...',
      price: '50000.00',
      osname: 'android',
      orderid: 'GPA.3335-6324-5054-01732',
      productid: 'cont0004',
    };
    paymentResult(payload);
  };
  const paymentResult = async (val: any) => {
    console.log(JSON.stringify(val));
    const temp = val.title.split('p');
    const title = `${temp[0]}p`;
    const payload: inAppPaymentProps = {
      order_id: val.orderid,
      title: title,
      os: val.osname,
      product_id: val.productid,
      price: Number(val.price),
    };
    const re = await insertInAppPayment(payload);
    console.log(`result`);
    console.log(re);
    setPayRecord();
  };
  const setPayRecord = () => {

  }
  const chargePoint = () => {
    console.log(payId);
    buy_contents(payId);
  };

  return (
    <Container sx={{ pb: 5 }}>
      <TopBackButton
        title="포인트 충전"
        boxProps={{
          mb: 4,
        }}
      />
      <Stack direction="row" justifyContent="space-between" mb={3.5} alignItems="center">
        <Typography variant="subtitle2" fontWeight={700}>
          충전금액
        </Typography>
        {/*TODO 인앱 테스트 후 해제
         <Typography variant="body2">
          충전 가능 금액{' '}
          <b style={{ color: SFPalette.shuffleColor, fontFamily: 'Inter' }}>
            {(POINT - chargeAmount).toLocaleString('ko-KR')}
          </b>
        </Typography> */}
      </Stack>
      <Box mb={3}>
        <TextField
          placeholder="충전할 금액 입력 (5,000원 단위 입력 가능)"
          fullWidth
          value={displayValue}
          InputProps={{
            endAdornment: chargeAmount > 0 && (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => {
                    setChargeAmount(0);
                  }}
                >
                  <CloseOutlined />
                </IconButton>
              </InputAdornment>
            ),
          }}
          onChange={handleInputChange}
        />
      </Box>
      <Grid container spacing={1} mb={4}>
        <Grid item xs={4}>
          <Button
            variant="outlined"
            onClick={() => {
              setChargeAmount(POINT);
            }}
            sx={{
              color: SFPalette.black,
              borderColor: SFPalette.lightGrey2,
              backgroundColor: 'white',
              '&:hover': {
                backgroundColor: SFPalette.lightGrey1,
              },
            }}
            fullWidth
          >
            최대 금액
          </Button>
        </Grid>
        {[5000, 10000, 30000, 50000, 100000].map((amount, idx) => (
          <Grid item xs={4} key={idx}>
            <Button
              variant="outlined"
              onClick={() => {
                // TODO 인앱 결제 테스트 후 해제
                // increaseChargeAmount(amount)
                setChargeAmount(amount);
                buyId(amount);
              }}
              fullWidth
              sx={{
                color: SFPalette.black,
                borderColor: SFPalette.lightGrey2,
                backgroundColor: 'white',
                '&:hover': {
                  backgroundColor: SFPalette.lightGrey1,
                },
              }}
            >
              +{amount.toLocaleString()}
            </Button>
          </Grid>
        ))}
      </Grid>
      {/* TODO 충전 수단 인앱결제때문 차단, 추후에 해제
      <Box mb={1}>
        <Typography variant="subtitle2" fontWeight={700} mb={1}>
          충전수단 선택
        </Typography>
        <RadioGroup value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)}>
          <FormControlLabel
            value="간편계좌"
            control={<Radio />}
            label={<Typography variant="body1">간편계좌</Typography>}
          />
          <FormControlLabel
            value="신용카드"
            control={<Radio />}
            label={<Typography variant="body1">신용카드</Typography>}
          />
        </RadioGroup>
      </Box>

      <Box display={paymentMethod === '간편계좌' ? 'none' : 'block'}>
        <ChargeAlert chargeAmount={chargeAmount} />
      </Box> */}
      <SFAccordion sx={{ mb: 4 }} header="포인트 충전 시 유의사항">
        <BulletList
          list={[
            '충전 금액에 수수료가 합산된 금액이 결제됩니다.',
            '최소 충전 포인트: 5,000P',
            '보유 가능 최대 포인트: 2,000,000P',
            '일월 최대 충전 한도: 2,000,000P',
            '포인트 충전수수료를 제외한 한도입니다.',
          ]}
        />
      </SFAccordion>
      <Stack direction="row" justifyContent="space-between" mb={5} alignItems="center">
        <Typography variant="subtitle2" color={SFPalette.black} fontWeight={700}>
          충전 후 예상 포인트 잔액
        </Typography>
        <Typography variant="h4" color={SFPalette.shuffleColor} fontWeight={700} fontFamily={inter.style.fontFamily}>
          {chargeAmount.toLocaleString('ko-KR')} P
        </Typography>
      </Stack>
      <BottomFix>
        <Button
          variant="contained"
          size="large"
          fullWidth
          onClick={() => chargePoint()}
          sx={{
            my: 2,
          }}
        >
          충전하기
        </Button>
      </BottomFix>
    </Container>
  );
}

export default PointChargePage;

// import { charge, chargeType } from '@/api/server/point/create';
// import { chargeAble } from '@/api/server/point/read';
// import { Button } from '@mui/material';
// import { useEffect, useState } from 'react';
// import Parser from 'html-react-parser';
// import ReactDom from 'react-dom/server';

// export default function Charge() {
//   const [limit, setLimit] = useState('0');
//   const [html, setHtml] = useState<any>();
//   const [html2, setHtml2] = useState<any>();
//   useEffect(() => {
//     (async () => {
//       const re = await chargeAble();
//       if (re.ret_code !== 200) {
//         return <>충전 가능 금액: 0</>;
//       }
//       setLimit(re.data);
//     })();

//     return () => {};
//   }, [limit]);

//   const handleClick = async () => {
//     const payload: chargeType = {
//       price: '5000',
//       type: 'account',
//     };
//     const re = await charge(payload);
//     console.log(typeof re);
//     console.log(re);
//     setHtml(`<!DOCTYPE html>
//     <html>
//     <head>
//       <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
//     <meta name="viewport" content="width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0" />
//     <title>MYPAY간편결제</title>
//     </head>
//     <body onload="javascript: document.KSPayWeb.submit();">
//       <form name="KSPayWeb" id="KSPayWeb" method="post" target="_self" action ="https://kspay.ksnet.to/store/MYPay/MYPayWeb.jsp" accept-charset="euc-kr">
//         <input type="hidden" name="sndThemecolor" value="000000">
//         <input type="hidden" name="sndLogotype" size="30" maxlength="30" value="1">
//         <input type="hidden" name="sndMsalt"  size="30" value="MA01">
//         <input type="hidden" name="sndEdata"  size="30" value="8FCA3FE1B977FA445FD6DB697FF968433DA7F0BE43E452D79C897E811C775582D16C3BD5C53F465CA13F54FAB0A142ADAABF4574AC3B7F5747983E7985147E20">
//         <input type="hidden" name="sndEtoken" size="30" value="20230706173909:9265F463FCF09147C5CF4322C676E536E6A42202969A04439D53E06A82B2A4DC">

//         <input type="hidden" name="sndOrdernumber" size="30" maxlength="30" value="il684nhod1eryz73">
//         <input type="hidden" name="sndStoreid"     size="10" maxlength="10" value="2010300002">
//         <input type="hidden" name="sndUserId"      size="30" maxlength="30" value="vldgsqysb3cuhhhn">
//         <input type="hidden" name="sndReply"       value="https://api.andblock.kr/v1/point/bank/result">
//         <input type="hidden" name="sndCancelUrl"   value="https://api.andblock.kr/v1/point/bank/result">
//         <input type="hidden" name="sndRetParam"    value="gzuhp0foyvfyg5oizqcrrojjmhshcqov">
//         <input type="hidden" name="sndCharSet"     value="">
//         <input type="hidden" name="sndGoodname"    size="30" maxlength="30" value="셔플 포인트">
//         <input type="hidden" name="sndAmount"      size="30" maxlength="30" value="5000">
//         <input type="hidden" name="sndOrdername"   size="30" maxlength="20" value="구제헌">
//         <input type="hidden" name="sndCashReceipt" size="30" maxlength="30" value="0">
//         <input type="hidden" name="sndEmail"       size="50" maxlength="50" value="rnwpgjs@naver.com">
//       </form>
//     </body>
//     </html>`);
//     setHtml2(ReactDom.renderToString(re));
//   };
//   function DangerouslySetInnerHTML({ html }: any) {
//     return <div dangerouslySetInnerHTML={html} />;
//   }
//   return (
//     <>
//       <h3>charge</h3>
//       충전 가능 금액: {limit}
//       <Button onClick={handleClick}>충전하기</Button>
//       {/* <MyComponent /> */}
//       <DangerouslySetInnerHTML
//         html={{
//           __html: html,
//         }}
//       />
//       {/* {html2} */}
//       <Button href={'https://kspay.ksnet.to/store/MYPay/MYPayWeb.jsp'}>asd</Button>
//       {html}
//       <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
//       <meta
//         name="viewport"
//         content="width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0"
//       />
//       <title>MYPAY간편결제</title>
//       <form
//         name="KSPayWeb"
//         id="KSPayWeb"
//         method="post"
//         target="_self"
//         action="https://kspay.ksnet.to/store/MYPay/MYPayWeb.jsp"
//         acceptCharset="euc-kr"
//       >
//         <input type="hidden" name="sndThemecolor" defaultValue={'000000'} />
//         <input type="hidden" name="sndLogotype" size={30} maxLength={30} defaultValue={1} />
//         <input type="hidden" name="sndMsalt" size={30} defaultValue="MA01" />
//         <input
//           type="hidden"
//           name="sndEdata"
//           size={30}
//           defaultValue="66CD219B87D58DBAE5068BD0B30DC6A6E480F07779D2D9301F9607CCE2842E6B2DEB70B83EB49FEE28B3ED17C5116C02D57CFA1FB97CE0A44CDF8DF2A6824B56"
//         />
//         <input
//           type="hidden"
//           name="sndEtoken"
//           size={30}
//           defaultValue="20230706173950:D4BD2B88F9C88B2566014150E2EF4C7B3D1EDBA0D1DDF9F39775FF4A063801A6"
//         />
//         <input type="hidden" name="sndOrdernumber" size={30} maxLength={30} defaultValue="7pbjvkrxbgc7jj6j" />
//         <input type="hidden" name="sndStoreid" size={10} maxLength={10} defaultValue={2010300002} />
//         <input type="hidden" name="sndUserId" size={30} maxLength={30} defaultValue="vldgsqysb3cuhhhn" />
//         <input type="hidden" name="sndReply" defaultValue="https://api.andblock.kr/v1/point/bank/result" />
//         <input type="hidden" name="sndCancelUrl" defaultValue="https://api.andblock.kr/v1/point/bank/result" />
//         <input type="hidden" name="sndRetParam" defaultValue="gzuhp0foyvfyg5oizqcrrojjmhshcqov" />
//         <input type="hidden" name="sndCharSet" defaultValue="" />
//         <input type="hidden" name="sndGoodname" size={30} maxLength={30} defaultValue="셔플 포인트" />
//         <input type="hidden" name="sndAmount" size={30} maxLength={30} defaultValue={5000} />
//         <input type="hidden" name="sndOrdername" size={30} maxLength={20} defaultValue="구제헌" />
//         <input type="hidden" name="sndCashReceipt" size={30} maxLength={30} defaultValue={0} />
//         <input type="hidden" name="sndEmail" size={50} maxLength={50} defaultValue="rnwpgjs@naver.com" />
//       </form>
//     </>
//   );
// }
